<div #wrapper class="chart-wrapper">
	<canvas #chartCanvas [attr.id]="canvasId"></canvas>
</div>
